import React from "react";
import { motion } from "framer-motion";
import { PROCESS } from "../data/site";

export const Process = () => {
  return (
    <section data-testid="process-section" className="scroll-mt-28 relative py-24 md:py-32 bg-slate-50 overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 max-w-3xl"
        >
          <div className="text-[11px] uppercase tracking-[0.22em] text-amber-600 font-bold flex items-center gap-2">
            <span className="w-8 h-px bg-amber-500" />
            Our Process
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-navy-900 tracking-tighter leading-[1]">
            Design. Prototype.
            <br />
            <span className="text-amber-500">Manufactured to last.</span>
          </h2>
        </motion.div>

        <div className="relative">
          <div className="hidden md:block absolute top-7 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-400/40 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-5">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.step}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative"
                data-testid={`process-step-${p.step}`}
              >
                <div className="relative w-14 h-14 rounded-full bg-white border-2 border-amber-500 flex items-center justify-center text-navy-900 mb-6 shadow-sm">
                  <p.icon className="w-6 h-6" />
                </div>
                <div className="font-mono text-xs text-amber-600 tracking-tight mb-2">
                  STEP / {p.step}
                </div>
                <h3 className="font-display text-2xl font-bold text-navy-900 tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                  {p.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
